const points = document.querySelectorAll(
  ".section-ucg .product-grid--carousel .slider__item .point-wrapper",
);
points.forEach((point) => {
  const button = point.querySelector("button");

  button.addEventListener("click", () => {
    console.log("🚀 ~ button:", button);

    point.classList.toggle("active");

    points.forEach((_point) => {
      if (_point !== point) {
        _point.classList.remove("active");
      }
    });
  });
});
